import React from 'react';

import ReactDOM from 'react-dom';

import { enableES5 } from 'immer';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';
import AuthProvider from './auth/AuthContext';
import prepareMirage from './prepareMirage';
import prepareSentry from './prepareSentry';

import './index.output.css';

prepareMirage();
prepareSentry();
enableES5();

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
